import { SkeletonActionTypes } from "./actionTypes";
import { ActionCreator, Action } from "./actions";

export const SkeletonActionCreators: { [key: string]: ActionCreator } = {
    initialize: (): Action => ({
        type: SkeletonActionTypes.INITIALIZE
    }),

    readSubAppsConfig: (data): Action => ({
        type: SkeletonActionTypes.READ_SUBAPPS_CONFIG,
        payload: data
    })
};
